import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const BannerContainer = styled.section`
  background-color: ${props => props.theme.colors.secondaryColor};
  padding: 60px 0;
  color: white;
  text-align: center;
`;

const BannerTitle = styled.h1`
  font-size: ${props => props.theme.fontSizes.xxxlarge};
  color: white;
  margin-bottom: 15px;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.fontSizes.xxlarge};
  }
`;

const BreadcrumbContainer = styled.div`
  color: #ddd;
  
  a {
    color: ${props => props.theme.colors.primaryColor};
    
    &:hover {
      color: white;
    }
  }
  
  span {
    color: white;
  }
`;

const Banner = ({ title, parentPage, parentPath }) => {
  return (
    <BannerContainer>
      <div className="container">
        <BannerTitle>{title}</BannerTitle>
        <BreadcrumbContainer>
          <Link to="/">Home</Link>
          {parentPage && parentPath && (
            <>
              {' / '}
              <Link to={parentPath}>{parentPage}</Link>
            </>
          )}
          {' / '}
          <span>{title}</span>
        </BreadcrumbContainer>
      </div>
    </BannerContainer>
  );
};

export default Banner;
